/** Texto del tiempo que le queda a una seña. Null si la fecha no se puede leer. */
export function formatDepositRemaining(expiresAtIso: string, now = Date.now()): string | null {
  const expiresAt = new Date(expiresAtIso).getTime();
  if (Number.isNaN(expiresAt)) return null;
  const remainingMs = expiresAt - now;
  if (remainingMs <= 0) return 'Seña vencida';
  const totalSeconds = Math.floor(remainingMs / 1000);
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;
  const clock =
    hours > 0
      ? `${hours}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`
      : `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
  return `Quedan ${clock}`;
}
